/** The Build button at the bottom right: it opens the build menu, and closes it again. */
import type { JSX } from 'react';

import { BUILD_COLOR } from '@core/palette';
import { closePanel, openPanel } from '@game/view/panels';
import { t } from '@i18n/index';
import { SideButton } from '@ui/components/SideButton';
import { useGame, useGameState, useLocale } from '@ui/hooks';

export function BuildButton(): JSX.Element {
  useLocale();
  const game = useGame();
  const open = useGameState((s) => s.panel === 'build');
  return (
    <SideButton
      id="build-button"
      icon="hammer"
      name={t('build.open')}
      aria={t('build.open-aria')}
      pressed={open}
      onPress={() => {
        if (open) closePanel(game);
        else openPanel(game, 'build');
      }}
      color={BUILD_COLOR}
    />
  );
}
